import React from 'react';
import classNames from 'classnames';
import type { AsElementLink } from './LinkTypes';

const SummaryCardLink: React.FC<AsElementLink<HTMLAnchorElement>> = ({
  className,
  asElement: Component = 'a',
  ...rest
}) => (
  <Component className={classNames('nhsuk-card__link', className)} {...rest} />
);

export default SummaryCardLink;